import React from 'react'
import { NavbarBorrowSystem } from "../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
import { CreateJobPositionFormTestComponent } from '../../components/Officer/CreateJobPositionFormTestComponent'
import { Footer } from "../../components/share/Footer";

export const CreateJobPositionFormTestContainer = () => {
  const titleName =
      "รายละเอียดการขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเพื่อดำเนินการทดสอบมาตรฐานฝีมือแรงงาน";
  
    return (
      <div className="page-container bg-landing">
        <NavbarBorrowSystem />
        <HeadTitle title={titleName} />
        <CreateJobPositionFormTestComponent />
        <Footer />
      </div>
    );
}
